import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";

const ApmPayments = () => {

    const [page, setPage] = useState<number>(1);
    const [totalpage, setTotalPage] = useState<number>(0);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { singleRoleData, setFilter, filter } = useContext(ClientContext);
    const location = useLocation();
    const [localFilters, setLocalFilters] = useState<any>({});
    const [clearClicked, setClearClick] = useState(0);
    
    return (
        <div className="apm-smt-root">

            <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
            .apm-smt-root {
            font-family: 'Plus Jakarta Sans', sans-serif;
            display: flex; flex-direction: column; gap: 20px;
            }
        `}</style>
        </div>
    );
}

export default ApmPayments;